import React, { useState, useEffect, useLayoutEffect } from 'react'

import { Button, Card, Form, Row, Typography, notification, Icon } from 'antd'
import { Formik } from 'formik'
import * as yup from 'yup'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomInput from '../../components/CustomInput/customInput'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const CreateProfile = function ({ match, history }) {
  const [formLayout] = useState('vertical')

  // Params url
  const { id } = match.params

  // Form configuration
  const [formValues, setFormValues] = useState({})

  const form = {
    initialValues: formValues,
    yupValidationCreate: yup.object().shape({
      name: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('description')))
    }),
    yupValidationUpdate: yup.object().shape({
      name: yup.string().max(60).typeError('must be string')
    }),
    onSubmit: async (values) => {
      if (!id) {
        const data = { ...values }
        data.isAdmin = !!data.isAdmin
        data.active = !!data.active
        storeProfiles(data)
      } else {
        const payload = {
          data: { ...values },
          id
        }
        for (const key in payload.data) {
          if (payload.data[key] === null) {
            delete payload.data[key]
          }
        }
        updateProfile(payload)
      }
    }
  }

  // Mount/Umount component
  useLayoutEffect(() => {
    const hasAccess = validRule(RULES.PROFILE) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    if (id) {
      retrieveCustomerTypes(id)
    } else {
      setFormValues({})
    }

    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setFormValues({})
    }
  }, [id])

  // Api requests
  async function storeProfiles(data) {
    try {
      await request(api.storeProfiles(data))
      notification.success({
        description: getMessage('successCreateProfile'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function retrieveCustomerTypes(customerId) {
    try {
      const response = await request(api.retrieveCustomerTypes(customerId))
      console.tron.log('response', response)
      setFormValues({
        ...response
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateProfile(payload) {
    try {
      console.tron.log('updateCustomerTypes')
      await request(api.updateProfiles(payload.id, payload.data))
      notification.success({
        description: getMessage('successUpdateProfile'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  function getTitle() {
    return id !== null ? getMessage('updateProfiles') : getMessage('createProfile')
  }

  function renderHeader(submitForm) {
    const hasAccess = id === null ? validRule(RULES.PROFILE) : validRule(RULES.CUSTOMER_TYPE)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={() => submitForm()}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({
              ...formValues,
              [field]: value
            })
            return setFieldValue(field, value)
          }

          return (
            <Form className="login-form" layout={formLayout} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <Typography.Title className="default-header-title" level={3}>
                  {getTitle()}
                </Typography.Title>
                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    unCheckedChildren={getMessage('label.inactive')}
                    checkedChildren={getMessage('label.active')}
                    defaultValue={false}
                  />
                  <CustomSwitch
                    field="isAdmin"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    unCheckedChildren={getMessage('label.no')}
                    checkedChildren={getMessage('label.yes')}
                    defaultValue={false}
                  />
                </Row>
                <Row type="flex" justify="start">
                  <CustomInput
                    field="name"
                    label="profileName"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    labelInput={getMessage('typeName')}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default CreateProfile
